import { TextField } from "@mui/material"
import { useState } from "react"
import useStore from "./useStore"
import { txt } from "../../../services/translation"

export default function ItemAdd(){

    const { addItem } = useStore()

    const [value, setValue] = useState('')

    const handleSubmit = e => {
        e.preventDefault()

        if(!value.replaceAll(' ', '')) return false;

        setValue('')

        addItem(value)
    }

    return <form onSubmit={handleSubmit}>

        <TextField 
            label={txt('addText')}
            value={value}
            onChange={e => setValue(e.target.value)}
            size='small'
            sx={{width: 200}}
        />

    </form>
}